export const transformArrayToSearchParams = (baseKey: string, values: string[]) =>
  values.map((value, index) => ({ key: `${baseKey}[${index}]`, value }));
